var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"column",staticClass:"column",style:({ width: `${_vm.width}px`, minWidth: `${_vm.minWidth}px` })},[_vm._t("default"),(!_vm.disabled)?_c('div',{class:`resizer resizer-${_vm.direction}`,on:{"mousedown":_vm.start}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }